import { useState } from "react";
import { CalendarDays, X } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { Button } from "@/components/ui/button";

const pad = (n) => String(n).padStart(2, "0");

function parse(value) {
  if (!value) return undefined;
  const m = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  return m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : undefined;
}

export default function DateField({ id, value, onChange }) {
  const [open, setOpen] = useState(false);
  const date = parse(value);
  const time = String(value || "").slice(10) || " 00:00:00";

  const pick = (d) => {
    if (!d) return;
    onChange(`${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}${time}`);
    setOpen(false);
  };

  return (
    <div className="flex gap-1">
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button id={id} type="button" variant="outline" data-testid={id}
            className="flex-1 justify-start font-normal hover:bg-secondary hover:text-foreground">
            <CalendarDays size={14} className="text-primary" />
            {date ? date.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" }) : <span className="text-muted-foreground">Pick a date</span>}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0 bg-card" align="start" data-testid={`${id}-calendar`}>
          <Calendar mode="single" selected={date} onSelect={pick} defaultMonth={date} initialFocus
            captionLayout="dropdown-buttons" fromYear={1900} toYear={new Date().getFullYear() + 20}
            classNames={{ caption_dropdowns: "flex gap-1.5", caption_label: "hidden", vhidden: "hidden",
              dropdown: "bg-secondary border rounded px-1.5 py-1 text-sm text-foreground focus:outline-none focus:ring-1 focus:ring-primary" }} />
        </PopoverContent>
      </Popover>
      {date && (
        <Button type="button" size="icon" variant="ghost" onClick={() => onChange("")} data-testid={`${id}-clear`} aria-label="Clear date">
          <X size={14} />
        </Button>
      )}
    </div>
  );
}
